import React from 'react'
import {
  ContentSection,
  ContentSectionHeading,
  ContentSectionWrapper,
  Image,
} from 'shared/SectionControl/NewSectionModal/components/ModalContent/pages/style'
import TextAndIconSectionImage from 'shared/SectionControl/NewSectionModal/components/ModalContent/assets/IconTextSection/icon-text-section.png'
import { useTranslation } from 'react-i18next'

export const IconTextPage = () => {
  const { t } = useTranslation()
  return (
    <ContentSectionWrapper>
      <ContentSectionHeading>{t('Icon & text section')}</ContentSectionHeading>
      <ContentSection>
        <Image alt="" src={TextAndIconSectionImage} />
      </ContentSection>
    </ContentSectionWrapper>
  )
}
